const CART_KEY_PREFIX = "chafadi-cart";

const dispatchCartUpdated = () => {
  window.dispatchEvent(new Event("chafadi-cart-updated"));
};

const currentCartKey = () => {
  const token =
    localStorage.getItem("chafadi-token") ||
    localStorage.getItem("access_token") ||
    "";
  if (!token) {
    return `${CART_KEY_PREFIX}:guest`;
  }
  return `${CART_KEY_PREFIX}:auth:${token.slice(0, 24)}`;
};

export const getCartItems = () => {
  try {
    return JSON.parse(localStorage.getItem(currentCartKey()) || "[]");
  } catch (error) {
    return [];
  }
};

export const setCartItems = (items) => {
  localStorage.setItem(currentCartKey(), JSON.stringify(items));
  dispatchCartUpdated();
};

export const addCartItem = (product, options = {}) => {
  const existing = getCartItems();
  const itemIndex = existing.findIndex((item) => item.id === product.id);
  const quantityToAdd = Math.max(1, Number(options.quantity || 1));
  const selectedSelections = Array.isArray(options.selectedSelections)
    ? options.selectedSelections
    : [];
  const customPrice =
    options.customPrice !== undefined && options.customPrice !== null && options.customPrice !== ""
      ? String(options.customPrice)
      : null;

  if (itemIndex >= 0) {
    existing[itemIndex] = {
      ...existing[itemIndex],
      quantity: (existing[itemIndex].quantity || 1) + quantityToAdd,
      selected_selections: selectedSelections,
      ...(customPrice ? { price: customPrice, min_price: customPrice, max_price: customPrice } : {}),
    };
  } else {
    existing.push({
      id: product.id,
      name: product.name,
      thumbnail_url: product.thumbnail_url,
      price: customPrice || product.price || product.max_price || product.min_price,
      min_price: customPrice || product.min_price,
      max_price: customPrice || product.max_price,
      quantity: quantityToAdd,
      minimum_order_quantity: product.minimum_order_quantity || 1,
      supplier: product.supplier || null,
      selected_selections: selectedSelections,
    });
  }

  setCartItems(existing);
};

export const removeCartItem = (productId) => {
  setCartItems(getCartItems().filter((item) => item.id !== productId));
};

export const isCartItem = (productId) =>
  getCartItems().some((item) => item.id === productId);

export const toggleCartItem = (product, options = {}) => {
  if (isCartItem(product.id)) {
    removeCartItem(product.id);
    return false;
  }
  addCartItem(product, options);
  return true;
};

export const updateCartItemQuantity = (productId, quantity) => {
  const next = getCartItems()
    .map((item) => (item.id === productId ? { ...item, quantity } : item))
    .filter((item) => item.quantity > 0);
  setCartItems(next);
};

export const getCartCount = () =>
  getCartItems().reduce((total, item) => total + (item.quantity || 1), 0);

export const clearCart = () => {
  setCartItems([]);
};

export const clearAllCartStorage = () => {
  Object.keys(localStorage)
    .filter((key) => key.startsWith(CART_KEY_PREFIX))
    .forEach((key) => localStorage.removeItem(key));
  dispatchCartUpdated();
};

export const syncCartScope = () => {
  dispatchCartUpdated();
};
